import { useOnValueChange } from '@calendly/hooks'
import { useCallback, useMemo, useState } from 'react'

import { EventTypeActionsContext, EventTypeStateContext } from './context'
import { withKindsAndTypes } from '../../services/event_types'

export const EventTypeProvider = ({
  children,
  eventType,
  justCreated = false,
  isSingleUseLink = false,
  singleUseLink = null,
  isLoading = false,
  error = null
}) => {
  const initialState = useMemo(() => ({
    eventType: withKindsAndTypes(eventType),
    isCreation: !eventType?.id,
    justCreated,
    isSingleUseLink,
    singleUseLink,
    isLoading,
    error
  }), [error, eventType, justCreated, isLoading, isSingleUseLink, singleUseLink])

  const [state, setState] = useState(initialState)

  useOnValueChange(initialState, () => {
    setState(initialState)
  })

  const setEventType = useCallback((newEventType) => (
    setState((prevState) => ({ ...prevState, eventType: withKindsAndTypes(newEventType) }))
  ), [])

  const actions = useMemo(() => ({
    setEventType
  }), [setEventType])

  return (
    <EventTypeStateContext.Provider value={state}>
      <EventTypeActionsContext.Provider value={actions}>
        {children}
      </EventTypeActionsContext.Provider>
    </EventTypeStateContext.Provider>
  )
}
